module.exports = __webpack_public_path__ + "static/masterclass-c31ac3122483ec7bb3bb06590dfcac40.jpg";